import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    username: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(true);
  const username = localStorage.getItem("username");

  useEffect(() => {
    if (!username) return;

    axios
      .get(`https://backend-zkgn.onrender.com/:3002/api/profile/${username}`)
      .then((res) => {
        setFormData({
          firstname: res.data.firstname,
          lastname: res.data.lastname,
          username: res.data.username,
          email: res.data.email,
          password: "", // keep password blank always
        });
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading profile:", err);
        setLoading(false);
      });
  }, [username]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .put(`https://backend-zkgn.onrender.com/:3002/api/profile/${username}`, formData)
      .then((res) => {
        alert(res.data.message);

        // 🔥 Navigate back to previous page
        navigate(-1);
      })
      .catch((err) => {
        console.error("Error updating profile:", err);
      });
  };

  if (loading) return <h3 className="text-center mt-4">Loading...</h3>;

  return (
    <div className="container my-4">
      <h2 className="mb-4">My Profile</h2>

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>First Name</label>
            <input
              className="form-control"
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Last Name</label>
            <input
              className="form-control"
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label>Username</label>
          <input
            className="form-control"
            type="text"
            name="username"
            value={formData.username}
            disabled
          />
        </div>

        <div className="mb-3">
          <label>Email</label>
          <input
            className="form-control"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>New Password (Optional)</label>
          <input
            className="form-control"
            type="password"
            name="password"
            value={formData.password}
            placeholder="Enter new password"
            onChange={handleChange}
          />
          <small className="text-muted">
            Leave empty if you do not want to change the password
          </small>
        </div>

        <button className="btn btn-primary mt-2" type="submit">
          Update Profile
        </button>
      </form>
    </div>
  );
}

export default Profile;
